<div class="EFLanding">
    @if (isLoading) {
        <app-pg-loading [isOverlay]="true" [isLarge]="true"></app-pg-loading>
    }
    @if (!isLoading) {
        <app-ef-main [appMode]="appMode" [sendEvents]="true" [setView]="setView" [externalFilter]="externalFilter" [fragment]="fragment" [hasOperatorsBanner]="hasOperatorsBanner" [hasShowcase]="hasShowcase" [hasShowcaseWithQR]="hasShowcaseWithQR" [showcaseContent]="showcaseContent" (fragmentChange)="onFragmentChange($event)"></app-ef-main>
    }
</div>
